import './components/share'

import './scss/st6/styles.scss'
